module.exports = __webpack_public_path__ + "img/off.a585eb42.svg";